import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: SarinManS
 * id E97AD67E-DD75-4FD8-9E25-44F3042B4172
 * name shoe-heel
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shoe-heel.svg
 * tags
 * - Clothing 
 */
export const ShoeHeelIcon = createSvgIcon(<><path d="M3,18H11.7L17,14H18V18H20V14C20,14 21,12 21,10C21,8 20.5,6 20.5,6H18.5L18,7L10,14H8L3,16V18Z" /></>, 'ShoeHeelIcon');
export default ShoeHeelIcon